import { useEffect } from 'react'

import { IonList } from '@ionic/react'
import { useParams } from 'react-router'

// Components
import CompetitorProfileCard from '../root/CompetitorProfileCard'
import EventsProfileListing from '../root/EventsProfileListing'
import WrapperContainer from '../../../components/common/wrappers/WrapperContainer'
import OrganizerProfileCard from '../../../components/organizerSideProfileCard/OrganizerProfileCard'

import useProfileHook from '../../../hooks/users/competitor/profile/useProfileHook'
import { getConvertedData } from '../../../models/interface.helper'

// Redux
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  selectVisitedUserDetailsR,
  selectVisitedUserProfileDetailsR,
  setVisitedUserDetailsAc,
  setVisitedUserProfileDetailsAc,
} from '../../../store/profilePage/profilePageSlice'
import { selectProfileData } from '../../../store/user/userSlice'

import { CONST } from '../../../const/const'
import { IUserInterfaceExtended } from '../../../models/users/user.interface'

// Types
type Props = {
  handleModal: (showHide: boolean, typeOfModal: string, data?: Object) => void
  title: string
  activeTab: number
  isOthersProfile?: boolean
}

const AllEventPageWrapper = ({ handleModal }: Props) => {
  // Hooks and vars
  const { userId: visitedUserProfileId } = useParams<{ userId: string }>()
  const { userId: teamMemberId } = useParams<{ userId: string }>()

  const dispatch = useAppDispatch()

  const { getModelledProfileDataFn } = useProfileHook({ dontFetch: false })

  const visitedUserDetails = useAppSelector(selectVisitedUserDetailsR)
  const loggedInUserProfileDetailsR = useAppSelector(selectProfileData)
  const visitedUserProfileDetailsR = useAppSelector(selectVisitedUserProfileDetailsR)

  useEffect(() => {
    if (visitedUserProfileId) getUserDetails(visitedUserProfileId)

    if (teamMemberId) getUserDetails(teamMemberId)

    return () => {
      dispatch(setVisitedUserProfileDetailsAc(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitedUserProfileId, teamMemberId])

  useEffect(() => {
    if (
      (!loggedInUserProfileDetailsR && !visitedUserProfileDetailsR) ||
      (visitedUserProfileId && !visitedUserProfileDetailsR)
    )
      return

    let isOthersProfile = false
    let profileDetails: IUserInterfaceExtended | null = null
    let isOrganizerProfileView = false

    if (
      (visitedUserProfileDetailsR &&
        visitedUserProfileDetailsR.id !== loggedInUserProfileDetailsR.id) ||
      (visitedUserProfileId && visitedUserProfileId !== loggedInUserProfileDetailsR?.id)
    )
      isOthersProfile = true

    if (
      (visitedUserProfileDetailsR?.userType === CONST.USE_MODE.ORGANIZER && isOthersProfile) ||
      (loggedInUserProfileDetailsR?.userType === CONST.USE_MODE.ORGANIZER && !isOthersProfile)
    )
      isOrganizerProfileView = true

    if (isOthersProfile && visitedUserProfileDetailsR) profileDetails = visitedUserProfileDetailsR
    else if (loggedInUserProfileDetailsR) profileDetails = loggedInUserProfileDetailsR

    if (profileDetails) {
      dispatch(
        setVisitedUserDetailsAc({
          isMyProfile: !isOthersProfile,
          isOrganizerProfileView,
          profileDetails,
        })
      )
    } else dispatch(setVisitedUserDetailsAc(null))

    return () => {
      dispatch(setVisitedUserDetailsAc(null))
    }
  }, [dispatch, loggedInUserProfileDetailsR, visitedUserProfileDetailsR, visitedUserProfileId])

  // Functions
  async function getUserDetails(userId: string) {
    let res = await getModelledProfileDataFn(userId)
    dispatch(setVisitedUserProfileDetailsAc(getConvertedData(res)))
  }

  return (
    <WrapperContainer
      title="Profile"
      noBg={true}
      removeShadow={true}
      removePadding={true}
      hideTitle={false}
    >
      <div className="flex lg:flex-row flex-col gap-6 flex-1">
        <IonList className="home_root_ion_list lg:max-w-[435px]">
          {visitedUserDetails?.isOrganizerProfileView ? (
            <OrganizerProfileCard
              isMyProfile={!!visitedUserDetails?.isMyProfile}
              handleModal={handleModal}
            />
          ) : (
            <CompetitorProfileCard isMyProfile={!!visitedUserDetails?.isMyProfile} />
          )}
        </IonList>
        <IonList className="home_root_ion_list flex flex-col flex-1 overflow-x-auto">
          <EventsProfileListing />
        </IonList>
      </div>
    </WrapperContainer>
  )
}

export default AllEventPageWrapper
